import React from 'react';

interface TextViewerProps {
    content: string;
}

const TextViewer: React.FC<TextViewerProps> = ({ content }) => {
    return (
        <div
            className="relative max-w-[90vw] max-h-[90vh] bg-neutral-200 text-neutral-800 p-6 rounded-xl overflow-auto"
            onClick={(e) => e.stopPropagation()}
            style={{
                width: '75vw',
                height: '75vh'
            }}
        >
            <pre className="whitespace-pre-wrap break-words font-sans">{content}</pre>
        </div>
    );
};

export default TextViewer;